import { useMemo } from "react";
import { LOCATION_HISTORY_PATH_TYPES } from "../constants";
import { useNavigationHistoryPath } from "../store";
import dayjs from "dayjs";

export const useCalculateTravelHours = () => {
  const path = useNavigationHistoryPath();

  return useMemo(() => {
    const h = path?.reduce((hours, item) => {
      if (LOCATION_HISTORY_PATH_TYPES.tracked !== item.type) {
        return hours;
      }

      const [from, to] = item.locations;

      const startTime = dayjs(from?.timestampUtc);
      const finishTime = dayjs(to?.timestampUtc);
      const hoursByPath = dayjs.duration(finishTime.diff(startTime)).asHours();

      return hours + hoursByPath;
    }, 0);

    return Math.round(h ?? 0);
  }, [path]);
};
